class PrivateSaleModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    document.body.classList.toggle('util-SiteOverflowed', true)

    this.setAttribute('aria-hidden', 'false')
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)
    this.handleApply = this.handleApply.bind(this)
    this.handleCopy = this.handleCopy.bind(this)

    if (this.els?.close?.exists) {
      this.listeners.add(this.els.close.element, 'click', this.handleClose)
    }

    if (this.els?.apply?.exists) {
      this.listeners.add(this.els.apply.element, 'click', this.handleApply)
    }

    if (this.els?.copy?.exists) {
      this.listeners.add(this.els.copy.element, 'click', this.handleCopy)
    }

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRIVATE_SALE.ON_SUCCESS,
      this.onSuccess.bind(this),
    )
  }

  handleClose () {
    document.body.classList.toggle('util-SiteOverflowed', false)

    this.setAttribute('aria-hidden', true)

    this.setCartAttribute()
  }

  async handleApply (e) {
    const applyButton = e.target.closest(this.els?.apply?.selector)
    if (!applyButton) return

    e.preventDefault()

    await this.setCartAttribute()

    if (applyButton.hasAttribute('href')) {
      window.location.href = applyButton.getAttribute('href')
    }
  }

  handleCopy (e) {
    const copyButton = e.target.closest(this.els?.copy?.selector)
    if (!copyButton) return

    const discountCode = copyButton.dataset.discountCode
    if (!discountCode) return

    navigator.clipboard.writeText(discountCode).then(() => {
      const textEl = copyButton.querySelector(
        '[data-private-sale-modal-el="copy-text"]',
      )

      if (!textEl) return

      textEl.innerText = copyButton.dataset.copiedText

      setTimeout(() => {
        textEl.innerText = copyButton.dataset.defaultText
      }, 1500)
    })
  }

  onSuccess () {
    const blurEl = this.els.blur?.element

    if (blurEl) blurEl.setAttribute('aria-hidden', 'true')
  }

  async setCartAttribute () {
    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'true',
        },
      }),
    })
  }

  get storageName () {
    return 'bao_private_sale_modal_closed'
  }
}

if (!customElements.get('private-sale-modal')) {
  customElements.define('private-sale-modal', PrivateSaleModal)
}
